import { ArrowRight, MapPin, Clock, Users, Star, IndianRupee } from "lucide-react";

/* Phone Mockup A: Co-traveller booking screen (dark navy accent) */
export const PassengerMockup = () => (
  <div data-testid="phone-mockup-passenger" className="phone-frame relative w-[280px] h-[560px] mx-auto">
    <div className="phone-notch" />
    <div className="absolute inset-0 p-4 pt-9 flex flex-col">
      <div className="flex items-center justify-between text-[10px] font-body text-gray-500 px-1">
        <span>9:41</span>
        <span className="flex gap-1">
          <span className="w-3 h-2 rounded-sm bg-gray-300" />
          <span className="w-3 h-2 rounded-sm bg-gray-300" />
        </span>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#24303F] font-display font-bold">
            Mode · Co-traveller
          </div>
          <div className="font-display text-xl font-bold mt-1 text-[#24303F]">Find a ride</div>
        </div>
        <div className="h-8 w-8 rounded-full bg-[#24303F]/10 border border-[#24303F]/20 grid place-items-center">
          <Users className="w-3.5 h-3.5 text-[#24303F]" />
        </div>
      </div>

      {/* Search card */}
      <div className="mt-4 rounded-2xl border border-[#e5e7eb] bg-white p-3">
        <Row label="From" value="Saket, Delhi" />
        <div className="h-px bg-[#e5e7eb] my-2" />
        <Row label="To" value="Gurgaon Sec 29" />
      </div>

      {/* Ride results */}
      <div className="mt-4 space-y-2.5 flex-1 overflow-hidden">
        <RideCard name="Aarav S." rating="4.9" time="9:30 AM" seats="2 left" price="₹120" highlight />
        <RideCard name="Priya M." rating="4.8" time="9:45 AM" seats="3 left" price="₹140" />
        <RideCard name="Rohan K." rating="4.7" time="10:00 AM" seats="1 left" price="₹110" />
      </div>

      <button className="mt-3 w-full rounded-xl bg-[#24303F] text-white font-display font-bold py-2.5 text-sm flex items-center justify-center gap-1.5">
        Book seat <ArrowRight className="w-3.5 h-3.5" />
      </button>
    </div>
  </div>
);

/* Phone Mockup B: Trip Host posting screen (green theme) */
export const HostMockup = () => (
  <div data-testid="phone-mockup-host" className="phone-frame relative w-[280px] h-[560px] mx-auto">
    <div className="phone-notch" />
    <div className="absolute inset-0 p-4 pt-9 flex flex-col">
      <div className="flex items-center justify-between text-[10px] font-body text-gray-500 px-1">
        <span>9:41</span>
        <span className="flex gap-1">
          <span className="w-3 h-2 rounded-sm bg-gray-300" />
          <span className="w-3 h-2 rounded-sm bg-gray-300" />
        </span>
      </div>

      <div className="mt-4 flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#5FA836] font-display font-bold">
            Mode · Trip Host
          </div>
          <div className="font-display text-xl font-bold mt-1 text-[#24303F]">Post a trip</div>
        </div>
        <div className="h-8 w-8 rounded-full bg-[#5FA836]/15 border border-[#5FA836]/30 grid place-items-center">
          <MapPin className="w-3.5 h-3.5 text-[#5FA836]" />
        </div>
      </div>

      {/* Trip card */}
      <div className="mt-4 rounded-2xl border border-[#5FA836]/30 bg-[#5FA836]/5 p-3">
        <Row label="Departure" value="Saket, Delhi" />
        <div className="h-px bg-[#e5e7eb] my-2" />
        <Row label="Drop" value="Cyber Hub, Gurgaon" />
        <div className="h-px bg-[#e5e7eb] my-2" />
        <div className="flex items-center justify-between text-[11px] font-body">
          <span className="flex items-center gap-1.5 text-gray-500">
            <Clock className="w-3 h-3" /> 9:30 AM
          </span>
          <span className="flex items-center gap-1.5 text-gray-500">
            <Users className="w-3 h-3" /> 3 seats
          </span>
        </div>
      </div>

      {/* Earnings */}
      <div className="mt-4 rounded-2xl border border-[#e5e7eb] bg-white p-3">
        <div className="text-[10px] uppercase tracking-[0.2em] text-gray-500 font-display font-bold">
          Estimated earning
        </div>
        <div className="mt-1 font-display text-3xl font-black text-[#5FA836] flex items-center">
          <IndianRupee className="w-5 h-5" strokeWidth={3} />
          360
        </div>
        <div className="text-[11px] font-body text-gray-500">3 seats × ₹120</div>
      </div>

      <div className="flex-1" />

      <button className="mt-3 w-full rounded-xl bg-[#5FA836] text-white font-display font-bold py-2.5 text-sm flex items-center justify-center gap-1.5">
        Post trip <ArrowRight className="w-3.5 h-3.5" />
      </button>
    </div>
  </div>
);

const Row = ({ label, value }) => (
  <div>
    <div className="text-[9px] uppercase tracking-[0.2em] text-gray-400 font-display font-bold">
      {label}
    </div>
    <div className="font-body text-[13px] text-[#24303F] mt-0.5 font-semibold">{value}</div>
  </div>
);

const RideCard = ({ name, rating, time, seats, price, highlight }) => (
  <div
    className={`rounded-xl border p-2.5 flex items-center justify-between ${
      highlight ? "border-[#5FA836]/40 bg-[#5FA836]/5" : "border-[#e5e7eb] bg-white"
    }`}
  >
    <div className="flex items-center gap-2">
      <div className="h-7 w-7 rounded-full bg-gradient-to-br from-[#24303F] to-[#5FA836] grid place-items-center text-[10px] font-display font-black text-white">
        {name[0]}
      </div>
      <div>
        <div className="font-body text-[11px] font-semibold text-[#24303F]">{name}</div>
        <div className="flex items-center gap-1 text-[9px] text-gray-500 font-body">
          <Star className="w-2.5 h-2.5 fill-[#5FA836] text-[#5FA836]" />
          {rating} · {time} · {seats}
        </div>
      </div>
    </div>
    <div className="font-display font-bold text-sm text-[#24303F]">{price}</div>
  </div>
);
